<template>
  <PageTemplate>
    <LoadingWidget v-if="loading" />
    <transition name="fade">
      <div v-if="!loading && item && item.title">
        <div class="primary--text text-h6 text-sm-h5 text-md-h4">
          <span class="font-bazinga">
            {{ item.title }}
          </span>
        </div>
        <div
          class="
            d-flex
            align-center
            grey--text
            text--darken-2
            pt-5
            justify-space-between
          "
        >
          <div class="d-flex gap-details">
            <div v-if="item.address" class="d-flex align-baseline">
              <v-icon color="grey lighten-3" size="16"
                >fas fa-map-marker-alt</v-icon
              >
              <span class="ml-2 grey--text text--lighten-3">
                {{ item.address }}
              </span>
            </div>
            <div v-if="item.date" class="d-flex align-baseline">
              <v-icon color="grey lighten-3" size="16">far fa-calendar</v-icon>
              <span class="ml-2 grey--text text--lighten-3">
                {{ formatDate(item.date, "short") }}</span
              >
            </div>
          </div>

          <ShareLinksWidget />
        </div>
        <div v-if="images && images.length" class="pt-2">
          <CoolLightBox :items="images" :index="index" @close="index = null" />

          <div class="img-list">
            <img
              class="d-block cursor-pointer"
              @click="index = keyImages"
              :src="img + '?resize=1&w=300'"
              width="100%"
              v-for="(img, keyImages) in images"
              :key="keyImages"
            />
          </div>
        </div>
      </div>
      <v-alert v-if="!images.length && !loading" type="warning" class="mt-10">
        Nenhuma imagem adicionada até o momento.
      </v-alert>
    </transition>
  </PageTemplate>
</template>

<script>
import CoolLightBox from "vue-cool-lightbox";
import PageTemplate from "../components/templates/PageTemplate.vue";
import ShareLinksWidget from "../components/widgets/ShareLinksWidget.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import { formatDate } from "../utils/formatDate";

const _config = {
  mod: `galleries`,
};
export default {
  data: () => ({
    loading: true,
    index: null,
    item: {},
    images: [],
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
  },
  methods: {
    formatDate,
    get() {
      this.loading = true;
      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .then((data) => {
          this.item = data;
          this.images = data.img.list.map(({ path }) => {
            return path ? this.files + path : "";
          });
        })
        .catch(() => this.$router.replace("/error404"))
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    itemId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    LoadingWidget,
    ShareLinksWidget,
    PageTemplate,
    CoolLightBox,
  },
};
</script>

<style lang="scss" scoped>
.gap-details {
  gap: 1.5rem;
}
.img-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 10px;

  img {
    aspect-ratio: 16 / 13;
    cursor: pointer;
    object-fit: cover;
    -o-object-fit: cover;
  }
  @media screen and (max-width: 960px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
